import http from "../../utils/http"

/**
 * 企业端查询帮助列表
 */
// sentType 表示企业端接口 区分平台端和企业端
 export function frontList(params,sentType) {
   let officialType = params.officialType ? params.officialType : ''
    return http({
        url: "/enterprise/front/support/list?title=" + params.title + '&officialType=' + officialType,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 帮助详情
 */

 export function frontdetail(params,sentType) {
    return http({
        url: "/enterprise/front/support/" + params.id + '?userId=' + params.userId + '&name=' + params.name,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 章节详情
 * 
 */

 export function chapterDetail(params,sentType) {
    return http({
        url: "/enterprise/front/support/chapter/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 下载详情
 * 
 */

 export function dowloadDetail(params) {
    return http({
        url: "/enterprise/front/app/" + params.id,
        method:"get",
        data: params,
    })
}

/**
 * 订单列表
 * 
 */

 export function orderList(params,sentType) {
    return http({
        url: `/enterprise/order/list?businessId=${params.id}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 取消订单 创建订单
 * 
 */

 export function editOrder(params,method,sentType) {
    return http({
        url: "/enterprise/order",
        method:method,
        data: params,
        sentType:sentType
    })
}

/**
 * 企业列表
 * 
 */

export function enBusiness(params,sentType) {
    return http({
        url: "/enterprise/business/list",
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 支付宝支付
 * 
 */

export function airPay(params,sentType) {
    return http({
        url: `/enterprise/aliPay?orderId=${params.id}&type=${params.type}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}


/**
 * 微信支付
 * 
 */
export function weChat(params,sentType) {
    return http({
        url: "/enterprise/wechatPay/" + params.id,
        method:"post",
        data: params,
        sentType:sentType
    })
}


/**
 * 订单详情
 * 
 */
export function orderDetail(params,sentType) {
    return http({
        url: "/enterprise/order/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}


/**
 * 微信支付交易订单
 * 
 */
export function weChatPayQuery(params,sentType) {
    return http({
        url: "/enterprise/wechatPay/query/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 *  查询支付宝交易订单
 * 
 */

export function airPayQuery(params,sentType) {
    return http({
        url: "/enterprise/aliPay/query/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 *  测试token是否过期
 * 
 */

export function tokenOnline(params,sentType) {
    return http({
        url: "/enterprise/online",
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 方案详情
 * 
 */
export function solutionDetail(params,sentType) {
    return http({
        url: "/enterprise/solution/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 新闻分类列表
 * 
 */

export function newsClassList(params,sentType) {
    return http({
        url: "/enterprise/newsClassify/list",
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 新闻动态详情
 * 
 */

export function newsDetail(params,sentType) {
    return http({
        url: "/enterprise/news/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 案例详情
 * 
 */

export function caseDetail(params,sentType) {
    return http({
        url: "/enterprise/case/" + params.id,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 应用、解决方案分类列表
 * 
 */

export function classList(params,sentType,index) {
    // 1、应用分类；2、解决方案分类
    let url = index == 1 ? `/enterprise/front/appClassify/list?officialType=${params.officialType || ''}` : `/enterprise/solutionClassify/list?officialType=${params.officialType || ''}`
    return http({
        url: url,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 应用、解决方案列表
 * 
 */
export function ProductList(params,sentType,index) {
    // 1、应用；2、解决方案
    let url = index == 1 ? `/enterprise/front/app/list?parentClassifyId=${params.id}&officialType=${params.officialType || ''}` : `/enterprise/solution/list?classifyId=${params.id}&officialType=${params.officialType || ''}`
    return http({
        url: url,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 有二级分类的应用列表
 * 
 */
export function appTlist(params,sentType) {
    return http({
        url: `/enterprise/front/appClassifyList/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 轮播图列表
 * 
 */
export function bannerList(params,sentType) {
    return http({
        url: `/enterprise/website/bannerList?channelFirst=${params.channelFirst}&channelSecond=${params.channelSecond}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 轮播图详情
 * 
 */

export function bannerDetail(params,sentType) {
    return http({
        url: `/enterprise/website/banner/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 主页配置
 * 
 */

export function pageList(params,sentType) {
    return http({
        url: `/enterprise/website/pageList/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 课程列表首页
 * 
 */

export function courseIndexList(params) {
    return http({
        url: `/enterprise/course/list?recommend=${params.recommend}&classifyId=${params.classifyId}&id=${params.id}&payType=${params.payType}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 课程列表分页
 * 
 */

export function courseIndexPage(params) {
    return http({
        url: `/enterprise/course/page?recommend=${params.recommend}&isPlat=1&classifyId=${params.classifyId}&id=${params.id}&payType=${params.payType}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 课程列表分页1
 * 
 */

export function courseIndexPage1(params) {
    return http({
        url: `/enterprise/course/page?recommend=${params.recommend}&isPlat=${params.isPlat}&classifyId=${params.classifyId}&id=${params.id}&payType=${params.payType}&current=${params.current}&size=${params.size}&businessId=${params.isPlat == 1 ? '' : params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 课程详情
 * 
 */
export function courseDetail(params) {
    return http({
        url: `/enterprise/course/${params.id}?accountId=${params.accountId}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 预览课程关联试卷列表
 * 
 */
export function enPaperList(params) {
    return http({
        url: `/platform/result/centList?courseId=${params.id}&state=${params.state}&practiceMode=${params.practiceMode}`,
        method:"get",
        data: params,
    })
}
/**
 * 课程分类列表
 * 
 */
export function courseClassify(params) {
    return http({
        url: `/platform/courseClassify/list?name=${params.name || ''}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 课程分类列表1
 * 
 */
export function courseClassify1(params) {
    return http({
        url: `/platform/courseClassify/list?name=${params.name || ''}&isPlat=${params.isPlat}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 和隆软件主页配置
 * 
 */

export function softList(params,sentType) {
    return http({
        url: `/enterprise/website/softList/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 新闻分类列表
 * 
 */
export function newsClassify(params,sentType) {
    return http({
        url: `/enterprise/newsClassify/list?officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 新闻列表
 * 
 */

export function newList(params,sentType) {
    return http({
        url: `/enterprise/news/list?classifyId=${params.id}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 查询分页新闻列表
 * 
 */

export function newPageList(params,sentType) {
    return http({
        url: `/enterprise/news/page?classifyId=${params.id}&current=${params.current}&size=${params.size}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 案例分类列表
 * 
 */
export function caseClassify(params,sentType) {
    return http({
        url: `/enterprise/caseClassify/list?officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 查询分页案例列表
 * 
 */

export function casePageList(params,sentType) {
    return http({
        url: `/enterprise/case/page?classifyId=${params.id}&current=${params.current}&size=${params.size}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 岗位分类
 */
export function enjobClassify(params,sentType) {
    return http({
        url: `/enterprise/jobClassify/list?officialType=${params.officialType || ''}`,
        method:'get',
        data: params,
        sentType:sentType
    })
}
/**
 * 招聘列表
 * 
 */
export function jobList(params,sentType) {
    return http({
        url:`/enterprise/job/list?classifyId=${params.classifyId}&workplace=${params.workplace}&hiringNeeds=${params.hiringNeeds}&searchContent=${params.searchContent}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 投递简历
 * 
 */
export function jobResume(params,sentType) {    
    return http({
        url: "/enterprise/jobResume",
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 人才详情
 * 
 */

export function jobDetail(params,sentType) {
    return http({
        url: `/enterprise/job/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改头像和姓名
 * 
 */
export function editInfo(params,sentType) {    
    return http({
        url: "/enterprise/businessAccount/updateAccount",
        method:"put",
        data: params,
        sentType:sentType
    })
}

/**
 * 修改密码发送验证码
 * 
 */

export function updatePwd(params,sentType) {
    return http({
        url: `/enterprise/businessAccount/updatePwd/sendCode/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 修改密码下一步
 * 
 */

export function verifyCode(params,sentType) {
    return http({
        url: '/enterprise/businessAccount/updatePwd/verifyCode',
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改密码
 * 
 */

export function updatePwdSub(params,sentType) {
    return http({
        url: '/enterprise/businessAccount/updatePwd',
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改手机发送验证码
 * 
 */

export function updatePhone(params,sentType) {
    return http({
        url: `/enterprise/businessAccount/updatePhone/sendCode/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改手机下一步
 * 
 */

export function verifyCode1(params,sentType) {
    return http({
        url: '/enterprise/businessAccount/updatePhone/verifyCode',
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改新手机发送验证码
 * 
 */

export function updateNewPhone(params,sentType) {
    return http({
        url: `/enterprise/businessAccount/updateNewPhone/sendCode/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改密码
 * 
 */

export function updateLoginName(params,sentType) {
    return http({
        url: '/enterprise/businessAccount/updateLoginName',
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 新增客户咨询
 * 
 */
export function conSult(params,sentType) {    
    return http({
        url: "/enterprise/consult",
        method:"post",
        data: params,
        sentType:sentType
    })
}

/**
 * 应用管理中心列表
 * getappGl
 */
export function appCenter(params,sentType) {
    return http({
        url: `/enterprise/front/appCenter/list?businessId=${params.id}&parentClassifyId=${params.parentClassifyId}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 查询企业信息
 * 
 */
export function getBusiness(params,sentType) {
    return http({
        url: `/enterprise/business/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 修改团队信息
 * 
 */
export function editBusiness(params,sentType) {    
    return http({
        url: "/enterprise/business",
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 查询当前用户信息
 * 
 */
export function getCurrentUser(params,sentType) {
    return http({
        url: `/enterprise/businessAccount/getCurrentUser/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 查询成员分类列表
 * 
 */

export function geAccountGroup(params) {
    return http({
        url: `/enterprise/accountGroup/list?businessId=${params.id}&name=${params.name}&accountId=${params.accountId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
} 
/**
 * 新增成员分类
 * 
 */
export function editAccountGroup(params,method) {
    return http({
        url:'/enterprise/accountGroup',
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 删除成员成员分类
 * 
 */

export function deletAccountGroup(params) {
    return http({
        url: `/enterprise/accountGroup/${params.id}`,
        method:"DELETE",
        data: params,
        sentType:'enterprise'
    })
} 
/**
 * 设置账号的成员分类
 * 
 */
export function saveAccountGroupRelation(params) {    
    return http({
        url: "/enterprise/accountGroup/saveAccountGroupRelation",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 批量设置账号的成员分类
 * 
 */
export function batchSaveAccountGroupRelation(params) {    
    return http({
        url: "/enterprise/accountGroup/batchSaveAccountGroupRelation",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 查询成员列表
 * 
 */

export function getbusinessAccount(params,sentType,authType) {
    // authType2 为应用权限设置页面组件使用
    let resUrl = authType == 2 ? 'list': 'page',
        current = authType == 2 ? '': `${params.current}`,
        size = authType == 2 ? '': `${params.size}`
    return http({
        url: `/enterprise/businessAccount/${resUrl}?businessId=${params.id}&loginName=${params.loginName}&userName=${params.userName}&groupId=${params.groupId}&current=${current}&size=${size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 已分配系统列表
 * 
 */
export function getAllocateList(params,sentType) {
    return http({
        url: `/enterprise/appAuth/allocate/appAuthAccountPage?businessId=${params.id}&accountId=${params.accountId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 账号详情
 * 
 */
export function getTeamDetail(params,sentType) {
    return http({
        url: `/enterprise/businessAccount/getAccountById?businessId=${params.businessId}&id=${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 退出团队
 * 
 */
export function exitTeam(params,sentType) {
    return http({
        url: `/enterprise/business/exitTeam/${params.id}`,
        method:"delete",
        data: params,
        sentType:sentType
    })
}
/**
 * 移交团队
 * 
 */
export function transferTeam(params,sentType) {
    return http({
        url:'/enterprise/business/transfer',
        method:"put",
        data: params,
        sentType:sentType
    })
}

/**
 * 查询应用账号权限树
 * 
 */ 

export function getappAuth(params,sentType) {
    return http({
        url: `/enterprise/appAuth/tree?businessId=${params.id}&accountId=${params.accountId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 邀请成员
 * 
 */
export function inviteAccount(params,sentType) {
    return http({
        url:'/enterprise/businessAccount/invite',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 设置成员
 * 
 */
export function editAccount(params,sentType) {
    return http({
        url:'/enterprise/businessAccount',
        method:"put",
        data: params,
        sentType:sentType
    })
}
/**
 * 删除成员
 * 
 */
export function deletAccount(params,sentType) {
    return http({
        url:'/enterprise/businessAccount',
        method:"DELETE",
        data: params,
        sentType:sentType
    })
}
/**
 * 关联企业列表
 * 
 */
export function getappGl(params,sentType) {
    return http({
        url: `/enterprise/appAuth/appList?businessId=${params.businessId}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 应用权限列表
 * 
 */
export function getAppAuthList(params,sentType) {
    return http({
        url: `/enterprise/appAuth/page?orderId=${params.orderId}&userName=${params.userName}&loginName=${params.loginName}&businessId=${params.id}&appId=${params.appId}&startTime=${params.startTime}&endTime=${params.endTime}&current=${params.current}&size=${params.size}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 课程权限列表
 * 
 */
export function getCourseAuthList(params,sentType) {
    return http({
        url: `/enterprise/courseAuthAccount/page?orderId=${params.orderId}&userName=${params.userName}&loginName=${params.loginName}&businessId=${params.id}&courseClassifyId=${params.courseClassifyId}&startTime=${params.startTime}&endTime=${params.endTime}&current=${params.current}&size=${params.size}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 课程权限详情
 * 
 */

export function getcourseAuthDetail(params,sentType) {
    return http({
        url: `/enterprise/courseAuthAccount/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 应用权限详情
 * 
 */

export function getappAuthDetail(params,sentType) {
    return http({
        url: `/enterprise/appAuth/${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 分配权限
 * 
 */
export function AssignAuth(params,sentType) {
    return http({
        url:'/enterprise/appAuth',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 分配课程权限
 * 
 */
export function courseAssignAuth(params,sentType) {
    return http({
        url:'/enterprise/courseAuthAccount',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-成员列表
 * 
 */
export function getTeacherAccount(params,sentType) {
    return http({
        url: `/exam/account/page?businessId=${params.id}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 教师管理端-关联仿真系统
 * 
 */

export function getTeacherAppList(params) {
    console.log(params)
    return http({
        url: `/exam/app/list?businessId=${params.id}&accountId=${params.accountId}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}

/**
 * 教师管理端-成员详情
 * 
 */
export function getMemberDetail(params,sentType) {
    return http({
        url: `/exam/account?businessId=${params.businessId}&id=${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 教师管理端-权限设置
 * 
 */

export function teacherAuth(params,sentType) {
    return http({
        url:'/exam/account',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-角色列表
 * 
 */
export function getRoleName(params,sentType) {
    return http({
        url: `/exam/role/page?roleName=${params.roleName}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 教师管理端-分页学员分类
 * 
 */

export function getStudentClass(params,sentType) {
    return http({
        url: `/exam/traineeClassify/page?businessId=${params.businessId}&name=${params.name}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 教师管理端-查询学员分类
 * 
 */
export function getAllStudentClass(params,sentType) {
    return http({
        url: `/exam/traineeClassify/list?businessId=${params.businessId}&name=${params.name}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-新增修改学员分类
 * 
 */

export function editStudentClass(params,method,sentType) {
    return http({
        url: "/exam/traineeClassify",
        method:method,
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-删除学员分类
 * 
 */
export function delestudenttList(params,method) {
    return http({
        url: `/exam/traineeClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 * 教师管理端-学员列表
 * 
 */
export function getStudentList(params,sentType) {
    return http({
        url: `/exam/trainee/page?businessId=${params.businessId}&classifyId=${params.classifyId}&userName=${params.userName}&loginName=${params.loginName}&appId=${params.appId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-学员列表1
 * 
 */
export function getStudentList1(params,sentType) {
    return http({
        url: `/exam/trainee/page?businessId=${params.businessId}&courseId=${params.courseId}&classifyId=${params.classifyId}&userName=${params.userName}&loginName=${params.loginName}&appId=${params.appId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-学员详情
 * 
 */
export function getStudentDetail(params,sentType) {
    return http({
        url: `/exam/trainee?businessId=${params.businessId}&id=${params.id}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-编辑学员详情
 * 
 */

export function saveTrainee(params,sentType) {
    return http({
        url:'/exam/trainee',
        method:"post",
        data: params,
        sentType:'sentType'
    })
}
/**
 * 教师管理端-设置学员分类
 * 
 */

export function saveTraineeClassifyRelation(params,sentType) {
    return http({
        url:'/exam/trainee/saveTraineeClassifyRelation',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-批量设置学员分类
 * 
 */

export function batchSaveTraineeClassifyRelation(params,sentType) {
    return http({
        url:'/exam/trainee/batchSaveTraineeClassifyRelation',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-分页题目列表
 * 
 */
export function questionList(params,sentType) {
    return http({
        url:`/exam/question/page?businessId=${params.businessId}&title=${params.title}&createBy=${params.createBy}&id=${params.id}&tags=${params.tags}&types=${params.types}&classifyId=${params.classifyId}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
         sentType:sentType
    })
}
/**
 * 教师管理端-分页题目分类
 * 
 */

export function getQuestionClass(params,sentType) {
    return http({
        url: `/exam/questionClassify/page?businessId=${params.businessId}&name=${params.name}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}

/**
 * 教师管理端-新增修改题目分类
 * 
 */

export function editQuestionClass(params,method,sentType) {
    return http({
        url: "/exam/questionClassify",
        method:method,
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-修改试卷中的题目题目
 * 
 */
export function editPaperQuestion(params) {
    return http({
        url: "/exam/paperQuestion",
        method:'PUT',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-删除题目分类
 * 
 */
export function deletQuestionClass(params,method) {
    return http({
        url: `/exam/questionClassify/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-题目查重
 * 
 */
export function enCheckHaveDuplicate(params,sentType) {
    return http({
        url: "/exam/question/checkHaveDuplicate",
        method:'post',
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-导入题目
 * 
 */

export function enimportSave(params,sentType) {
    return http({
        url: "/exam/question/importSave",
        method:'post',
        data: params,
        sentType:sentType
    })
}
/**
 * 申请试用-生成线索
 * 
 */

export function accountClue(params,sentType) {
    return http({
        url:'/enterprise/accountClue',
        method:"post",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-基础信息
 * 
 */
export function examControlInfo(params,sentType) {
    return http({
        url: `/exam/control/info?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-今日考试情况
 * 
 */
export function listTodayResult(params,sentType) {
    return http({
        url: `/exam/control/listTodayResult?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-今日仿真考试情况
 * 
 */
export function fzListTodayResult(params,sentType) {
    return http({
        url: `/assess/center/listTodayResult?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-正在进行的试卷考试列表
 * 
 */
export function listOngoingPaper(params,sentType) {
    return http({
        url: `/exam/control/listOngoingPaper?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-正在进行的仿真考试列表
 * 
 */
export function fzListOngoingPaper(params,sentType) {
    return http({
        url: `/assess/center/listOngoingPaper?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-试卷考试次数变化
 * 
 */
export function listResult(params,sentType) {
    return http({
        url: `/exam/control/listResult?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-控制中心-仿真考试次数变化
 * 
 */
export function fzListResult(params,sentType) {
    return http({
        url: `/assess/center/listResult?businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-我的应用
 * 
 */
export function appAllList(params,sentType) {
    return http({
        url: `/exam/app/allList?businessId=${params.businessId}&officialType=${params.officialType || ''}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 * 教师管理端-应用日志
 * 
 */
export function appLog(params,sentType) {
    return http({
        url: `/admin/log/appLogin/page?businessId=${params.businessId}&username=${params.username}&appName=${params.appName}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-新增、修改题目
 * 
 */

export function editEnQuestion(params,method,sentType) {
    return http({
        url: "/exam/question",
        method:method,
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-获取题目详情
 * 
 */

export function getEnQuestion(params,method,sentType) {
    return http({
        url: `/exam/question/${params.id}`,
        method:method,
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-移动到分类
 * 
 */
export function enmoveQuestion(params,sentType) {
    return http({
        url: "/exam/question/batchUpdateClassify",
        method:'put',
        data: params,
        sentType:sentType
    })
}
/**
 *  
 * 教师管理端-题库去重
 * 
 */
export function questionRepeat(params,sentType) {
    return http({
        url:`/exam/question/processQuestionsDuplication?businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-获取题目统计
 * 
 */
export function questionEnCount(params,sentType) {
    return http({
        url: `/exam/question/count/${params.id}?businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端 - 试卷分类
 * 
 */

export function listTree(params,sentType) {
    return http({
        url:`/exam/paperClassify/listTree?name=${params.name}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端 - 新增试卷分类
 * 
 */
export function editPaper(params,method,sentType) {
    return http({
        url: "/exam/paperClassify",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-删除试卷分类
 * 
 */

export function delpaperClassify(params,method,sentType) {
    return http({
        url: `/exam/paperClassify/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-分页查询试卷
 * 
 */

export function getPaperList(params,sentType) {
    return http({
        url:`/exam/paper/page?paperName=${params.paperName}&id=${params.id}&validPeriod=${params.validPeriod}&state=${params.state}&classifyId=${params.classifyId}&questionId=${params.questionId}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增试卷
 * 
 */

export function editPapeItem(params,method,sentType) {
    return http({
        url: "/exam/paper",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-获取试卷详情
 * 
 */

export function getPaper(params,method) {
    return http({
        url: `/exam/paper/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端 - 试卷ID查询仿真列表
 * 
 */
export function getPaperFzList(params) {
    return http({
        url: `/exam/paper/appList/${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-随机试题组卷
 * 
 */
export function randomPaper(params) {
    return http({
        url: "/exam/paperQuestion/random",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 固定试题组卷
 * 
 */
export function regularPaper(params) {
    return http({
        url: "/exam/paperQuestion",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 试卷ID删除试题
 * 
 */
export function topicDelet(params) {
    return http({
        url: `/exam/paperQuestion/${params.id}?delQuestion=${params.delQuestion}`,
        method:'DELETE',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 批量修改分数
 * 
 */

export function updatePaperScore(params) {
    return http({
        url: "/exam/paperQuestion/updateScore",
        method:'put',
        data: params,
        sentType:'enterprise'
    })
} 
/**
 *  
 * 试题查重
 * 
 */
export function duplicateList(params) {
    return http({
        url: `/exam/paperQuestion/duplicateList?paperId=${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 查询题目分类
 * 
 */
export function getAllTopicClassify(params) {
    return http({
        url:`/exam/questionClassify/list?name=${params.name}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 试卷ID查询题目列表
 * 
 */
export function getAllTopic(params) {
    return http({
        url: `/exam/paperQuestion/list/${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-考试成绩分析
 * 
 */
export function scoreAnalysis(params) {
    return http({
        url: `/exam/statistics/score?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-分数段统计
 * 
 */
export function segmentList(params) {
    return http({
        url: "/exam/statistics/segmentList",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-各类题型正确率
 * 
 */
export function countQuestionType(params) {
    return http({
        url: `/exam/statistics/countQuestionType?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-试题排行分析
 * 
 */
export function questionRankList(params) {
    return http({
        url: `/exam/statistics/questionRankList?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}&doRight=${params.doRight}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-考试记录分页面
 * 
 */

export function ResultList(params) {
    return http({
        url:`/exam/result/page?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&result=${params.result}&examiner=${params.examiner}&examinerPhone=${params.examinerPhone}&startTimeStart=${params.startTimeStart}&startTimeEnd=${params.startTimeEnd}&state=${params.state}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-考试监控基本信息
 * 
 */
export function monitor(params) {
    return http({
        url: `/exam/result/monitor/${params.id}?businessId=${params.businessId}&practiceMode=${params.practiceMode}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-缺考分页
 * 
 */
export function missExamPage(params) {
    return http({
        url:`/exam/result/missExamPage?paperId=${params.id}&businessId=${params.businessId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-查看成绩单
 * 
 */
export function resulttRanscript(params) {
    return http({
        url: `/exam/result/noLogin/${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-考试监控
 * 
 */
export function resultMonitorLog(params) {
    return http({
        url: `/exam/result/log/list?resultId=${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-强制交卷
 * 
 */
export function forceSubmit(params) {
    return http({
        url: `/exam/result/forceSubmit/${params.id}`,
        method:"put",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-试卷-学生组
 * 
 */
export function allocateList(params) {
    return http({
        url: `/exam/paper/allocateList/${params.id}?type=${params.type}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-课程-学生组
 * 
 */
export function courseAllocateList(params) {
    return http({
        url: `/enterprise/course/allocateList/?courseId=${params.id}&type=${params.type}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-试卷ID评分列表
 * 
 */
export function getComments(params) {
    return http({
        url: `/exam/paper/commentList/${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试中心-考试列表
 * 
 */
export function centList(params) {
    return http({
        url: `/exam/result/centList/?businessId=${params.businessId}&state=${params.state}&practiceMode=${params.practiceMode}&result=${params.result}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试中心-仿真考试列表
 * 
 */
export function exercisesList(params) {
    return http({
        url: `/assess/center/exercisesList/?businessId=${params.businessId}&state=${params.state}&practiceMode=${params.practiceMode}&result=${params.result}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试中心-考试记录
 * 
 */
export function centLog(params) {
    return http({
        url: `/exam/result/resultList/?businessId=${params.businessId}&state=${params.state}&practiceMode=${params.practiceMode}&result=${params.result}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试中心-仿真考试记录
 * 
 */
export function rasocentLog(params) {
    return http({
        url: `/assess/center/resultList/?businessId=${params.businessId}&state=${params.state}&practiceMode=${params.practiceMode}&result=${params.result}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试中心-获取试卷详情
 * 
 */
export function paperExam(params) {
    return http({
        url: `/exam/result/paperExam/${params.id}?view=${params.view}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理段-分类知识点答题正确率
 * 
 */
export function countRateQuestionClassifyList(params) {
    return http({
        url: `/exam/trainee/countRateQuestionClassifyList?businessId=${params.businessId}&practiceMode=${params.practiceMode}&accountId=${params.accountId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理段-仿真分类知识点答题正确率
 * 
 */

/**
 *  
 * 教师管理段-考生成绩变化趋势
 * 
 */
export function listDailyScore(params) {
    return http({
        url: `/exam/trainee/listDailyScore?businessId=${params.businessId}&practiceMode=${params.practiceMode}&accountId=${params.accountId}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理段-参与考试的试卷
 * 
 */
export function listExamResult(params) {
    return http({
        url: `/exam/trainee/pageExamResult?businessId=${params.businessId}&practiceMode=${params.practiceMode}&accountId=${params.accountId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-获取试卷题目详情
 * 
 */

export function getPaperEnQuestion(params) {
    return http({
        url: `/exam/paperQuestion/${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-排行榜列表
 * 
 */
export function rankList(params) {
    return http({
        url: `/exam/result/rankPage?businessId=${params.businessId}&practiceMode=${params.practiceMode}&paperId=${params.paperId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-删除记录
 * 
 */
export function deletResult(params) {
    return http({
        url: `/exam/result/${params.id}`,
        method:'DELETE',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 复制试卷
 * 
 */
export function copyPa(params) {
    return http({
        url: "/exam/paper/copy",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试监控-查询批卷基本信息
 * 
 */
export function getGrade(params) {
    return http({
        url:`/exam/result/grade/${params.id}?businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试监控-查询批卷题目分页
 * 
 */
export function getGradePage(params) {
    return http({
        url:`/exam/resultQuestion/gradeList?resultId=${params.resultId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考试监控-批卷
 * 
 */

export function grade(params) {
    return http({
        url: "/exam/resultQuestion/grade",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 仿真考试-分页查询试卷列表
 * 
 */
export function getEmuPaper(params) {
    return http({
        url:`/assess/emuPaper/page?businessId=${params.businessId}&paperName=${params.paperName}&validPeriod=${params.validPeriod}&appId=${params.appId}&state=${params.state}&omId=${params.omId}&id=${params.id}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 新增仿真试卷
 * 
 */

export function editEmuPaper(params,method) {
    return http({
        url: "/assess/emuPaper",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 查询仿真试卷详情
 * 
 */

export function EmuPaperDetail(params,method) {
    return http({
        url:`/assess/emuPaper/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 工况列表
 * 
 */
export function omList(params) {
    return http({
        url:`/platform/om/list?appId=${params.appId}&id=${params.id}&name=${params.name}`,
        method:'get',
        data: params,
         sentType:'enterprise'
    })
}
/**
 *  
 * 仪表阀门列表
 * 
 */
export function instrumentList(params) {
    return http({
        url:`/assess/emuPaper/instrumentList?appId=${params.appId}&search=${params.search}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 获取过程详情、删除过程
 * 
 */

export function getProcess(params,method) {
    return http({
        url: `/assess/emuPaper/process/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 新增编辑过程
 * 
 */
export function editProcess(params,method) {
    return http({
        url: `/assess/emuPaper/process`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 过程列表
 * 
 */
export function processList(params) {
    return http({
        url:`/assess/emuPaper/process/list?paperId=${params.paperId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 获取步骤列表
 * 
 */
export function stepList(params) {
    return http({
        url:`/assess/emuPaper/step/list?paperId=${params.paperId}&processId=${params.processId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 新增编辑步骤
 * 
 */
export function editStep(params,method) {
    return http({
        url: `/assess/emuPaper/step`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 获取步骤详情
 * 
 */
export function getStep(params,method) {
    return http({
        url: `/assess/emuPaper/step/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 导入保存
 * 
 */
export function stepImportSave(params) {
    return http({
        url: "/assess/emuPaper/step/importSave",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 仿真试卷ID评分列表
 * 
 */
export function getemuComments(params) {
    return http({
        url: `/assess/emuPaper/commentList/${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-仿真学生组
 * 
 */
export function fzAllocateList(params) {
    return http({
        url: `/assess/emuPaper/allocateList/${params.id}?type=${params.type}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 仿真考试成绩分析
 * 
 */
export function rasoScoreAnalysis(params) {
    return http({
        url: `/assess/center/score?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 仿真分数段统计
 * 
 */
export function rasoSegmentList(params) {
    return http({
        url: "/assess/center/segmentList",
        method:"post",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 考核步骤分析
 * 
 */
export function stepRankList(params) {
    return http({
        url: `/platform/assessResult/stepRankList?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}&state=${params.state}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 仿真考试记录分页
 * 
 */

export function rasoResultList(params) {
    return http({
        url:`/assess/result/page?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&result=${params.result}&examiner=${params.examiner}&examinerPhone=${params.examinerPhone}&startTimeStart=${params.startTimeStart}&startTimeEnd=${params.startTimeEnd}&state=${params.state}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 * 仿真考试监控基本信息
 * 
 */
export function rasMonitor(params) {
    let ptype = (params.practiceMode == 1 || params.practiceMode == 0)  ? params.practiceMode : ''
    return http({
        url: `/assess/result/monitor/?paperId=${params.id}&businessId=${params.businessId}&practiceMode=${ptype}`,
        method:"get",
        data: params,
         sentType:'enterprise'
    })
}
/**
 *  
 *仿真考核排行榜列表
 * 
 */
 export function rasoRankList(params) {
    return http({
        url: `/assess/result/rankPage?paperId=${params.paperId}&businessId=${params.businessId}&practiceMode=${params.practiceMode}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 仿真考试查看成绩单
 * 
 */
export function rasoResulttRanscript(params) {
    return http({
        url: `/assess/result/${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 仿真考试监控日志
 * 
 */
export function rasoResultMonitorLog(params) {
    return http({
        url: `/assess/result/log/list?resultId=${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 仿真强制交卷
 * 
 */
export function rasoForceSubmit(params) {
    return http({
        url: `/assess/result/forceSubmit/${params.id}`,
        method:"put",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 删除记录
 * 
 */
export function rasoDeletResult(params) {
    return http({
        url: `/assess/result/${params.id}`,
        method:'DELETE',
        data: params,
    })
}
/**
 * 教师管理端-缺考分页
 * 
 */
export function rasoMissExamPage(params) {
    return http({
        url:`/assess/result/missExamPage?paperId=${params.id}&businessId=${params.businessId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理段-仿真分类知识点答题正确率
 * 
 */
export function rasoCountResultRateByApp(params) {
    return http({
        url: `/assess/center/countResultRateByApp?businessId=${params.businessId}&practiceMode=${params.practiceMode}&accountId=${params.accountId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}

/**
 *  
 * 教师管理段-考生成绩变化趋势
 * 
 */
export function rasoListDailyScore(params) {
    return http({
        url: `/assess/center/listDailyScore?businessId=${params.businessId}&practiceMode=${params.practiceMode}&accountId=${params.accountId}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理段-参与仿真考试的试卷
 * 
 */
export function rasoListExamResult(params) {
    return http({
        url: `/assess/center/pageAssessResult?businessId=${params.businessId}&practiceMode=${params.practiceMode}&answerAccountId=${params.answerAccountId}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 触摸屏列表
 * 
 */
export function getListScreen(params) {
    return http({
        url: `/enterprise/touch/listScreen/${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 触摸屏详情
 * 
 */
export function getScreenDetail(params) {
    return http({
        url: `/enterprise/touch/screen/${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 证书分类
 * 
 */
export function getCertClass(params) {
    return http({
        url: `/exam/cert/classify/list`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 学习中心-证书列表分页
 * 
 */
export function getcertList(params) {
    let phone = params.phone || ''
    return http({
        url:`/exam/cert/receive/page?classifyId=${params.classifyId}&phone=${phone}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 证书查询
 * 
 */
export function getreceiveCert(params) {
    return http({
        url:`/exam/cert/receive?name=${params.name}&certificateNo=${params.certificateNo}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 章节树列表
 * 
 */
export function courseChapterTree(params,method) {
    return http({
        url: "/enterprise/course/chapter/treeList?courseId=" + params.id + '&businessId=' + params.businessId,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 章节详情
 * 
 */

export function courseChapterDetail(params,method) {
    return http({
        url: "/enterprise/course/chapter/" + params.id + '?businessId=' + params.businessId,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-学习记录分页
 * 
 */
export function courserRecordList(params) {
    return http({
        url: `/enterprise/course/record/page?businessId=${params.businessId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-课程列表
 * 
 */
export function courserMyList(params) {
    let accountId = params.accountId || ''
    return http({
        url: `/enterprise/course/my/list?businessId=${params.businessId}&classifyId=${params.classifyId}&accountId=${accountId}&isPlat=${params.isPlat}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-答题次数
 * 
 */
export function countByDay(params) {
    return http({
        url: `/exam/resultQuestion/countByDay?businessId=${params.businessId}&classsifyId=${params.classifyId}&title=${params.title}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-错题率
 * 
 */
export function wqRate(params) {
    return http({
        url: `/exam/resultQuestion/getRate?businessId=${params.businessId}&classsifyId=${params.classifyId}&title=${params.title}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-错题记录
 * 
 */
export function wrongPage(params) {
    return http({
        url: `/exam/resultQuestion/wrongPage?businessId=${params.businessId}&classsifyId=${params.classifyId}&title=${params.title}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-错题详情
 * 
 */
export function wrongDetail(params) {
    return http({
        url: `/exam/resultQuestion/wrongDetail/${params.id}?businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 数据分析-学习数据概况
 * 
 */
export function overviewCou(params) {
    return http({
        url: `/enterprise/course/learned/overview?courseId=${params.id}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 数据分析-学习数据概况
 * 
 */
export function lineData(params) {
    return http({
        url: `/enterprise/course/learned/countRecordByDay?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 数据分析-完课数据概况
 * 
 */
export function lineData1(params) {
    return http({
        url: `/enterprise/course/learned/countCompleteByDay?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 数据分析-学习详情分页
 * 
 */
export function tabData(params) {
    return http({
        url: `/enterprise/course/recordDetail/page?courseId=${params.id}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}

/**
 *  
 * 教师管理端-报警列表分页
 * 
 */
export function getAlarmClassify(params) {
    return http({
        url:`/assess/alarmClassify/page?appId=${params.appId}&name=${params.name}&businessId=${params.businessId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增报警分类
 * 
 */
export function editAlarm(params,method) {
    return http({
        url: "/assess/alarmClassify",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询、删除报警
 * 
 */

export function getAlarm(params,method) {
    return http({
        url: `/assess/alarmClassify/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-报警分类列表
 * 
 */
export function getAlarmClassify1(params) {
    return http({
        url:`/assess/alarmClassify/list?appId=${params.appId}&name=${params.name}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-报警列表分页
 * 
 */
export function alarmRuleList(params) {
    return http({
        url:`/assess/alarmRule/page?businessId=${params.businessId}&name=${params.name}&id=${params.id}&classifyId=${params.classifyId}&state=${params.state}&alarmLevel=${params.alarmLevel}&autoLock=${params.autoLock}&interlock=${params.interlock}&resetMode=${params.resetMode}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增编辑报警
 * 
 */
export function editAlarmRule(params,method) {
    return http({
        url: "/assess/alarmRule",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-报警触发条件列表
 * 
 */
export function triggerAlarmRule(params) {
    return http({
        url:`/assess/alarmRule/listTrigger?ruleId=${params.ruleId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-复位条件条件列表
 * 
 */
export function triggerAlarmRule1(params) {
    return http({
        url:`/assess/alarmRule/listReset?ruleId=${params.ruleId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查看删除报警规则
 * 
 */
export function getAlarmRule(params,method) {
    return http({
        url:`/assess/alarmRule/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-素材库分类分页
 * 
 */
export function materialClassify(params) {
    return http({
        url:`/enterprise/materialClassify/page?name=${params.name}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增素材库分类
 * 
 */
export function editMaterialClassify(params,method) {
    return http({
        url: "/enterprise/materialClassify",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询、删除素材库分类
 * 
 */

export function getMaterialClassify(params,method) {
    return http({
        url: `/enterprise/materialClassify/${params.id}`,
        method:method,
        data: params,
         sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-素材库分类列表
 * 
 */
export function materialAllClassify(params) {
    return http({
        url:`/enterprise/materialClassify/list?name=${params.name}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-素材库分页
 * 
 */
export function materialPage(params) {
    return http({
        url:`/enterprise/material/page?name=${params.name}&classifyId=${params.classifyId}&id=${params.id}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增修改素材库
 * 
 */
export function editMaterial(params,method) {
    return http({
        url: "/enterprise/material",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询、删除素材
 * 
 */

export function deletMaterial(params,method) {
    return http({
        url: `/enterprise/material/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-批量修改素材分类
 * 
 */

export function batchUpdateClassify(params) {
    return http({
        url: `/enterprise/material/batchUpdateClassify`,
        method:'put',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-分页查询课程分类
 * 
 */

export function getcourseClassify(params) {
    return http({
        url:`/enterprise/courseClassify/page?name=${params.name}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增课程分类
 * 
 */
export function editCourse(params,method) {
    return http({
        url: "/enterprise/courseClassify",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询课程分类
 * 
 */
export function getAllCourseClassify(params) {
    return http({
        url:`/enterprise/courseClassify/list?name=${params.name}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询、删除课程
 * 
 */

export function getCourse(params,method) {
    return http({
        url: `/enterprise/courseClassify/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-课程列表分页
 * 
 */
export function getcourseList(params) {
    return http({
        url:`/enterprise/course/page?title=${params.title}&id=${params.id}&isPlat=${params.isPlat}&classifyId=${params.classifyId}&state=${params.state}&payType=${params.payType}&recommend=${params.recommend}&current=${params.current}&size=${params.size}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-新增修改课程
 * 
 */
export function addCourse(params,method) {
    return http({
        url: "/enterprise/course",
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-课程规格列表
 * 
 */

export function courseSkuList(params) {
    return http({
        url: `/enterprise/course/sku/list?courseId=${params.id}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-查询、删除课程
 * 
 */

export function deletCourse(params,method) {
    return http({
        url: `/enterprise/course/${params.id}`,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-课程章节列表
 * 
 */
export function courseChapterList(params) {
    return http({
        url: `/platform/courseChapter/list?courseId=${params.id}&businessId=${params.businessId}`,
        method:"get",
        data: params,
         sentType:'enterprise'
    })
}
/**
 * 教师管理端-新增章节
 * 
 */


export function editcourseHelpChapter(params,method) {
    return http({
        url: "/platform/courseChapter",
        method:method,
        data: params,
        sentType:'enterprise'
        
    })
}
/**
 * 教师管理端-章节详情
 * 
 */

export function courseChapterDetail1(params,method) {
    return http({
        url: "/platform/courseChapter/" + params.id,
        method:method,
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-批量新增章节
 * 
 */

export function courseChapter(params) {
    return http({
        url: `/platform/courseChapter/batch/save`,
        method:'post',
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-预览课程列表
 * 
 */
export function prevoewCpurseList(params) {
    return http({
        url: `/platform/course/preview/${params.id}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-预览课程关联试卷列表
 * 
 */
export function prevoewPaperList(params) {
    return http({
        url: `/platform/result/centList?courseId=${params.id}&state=${params.state}&practiceMode=${params.practiceMode}`,
        method:"get",
        data: params,
        sentType:'enterprise'
    })
}
/**
 * 教师管理端-取消指派学员
 * 
 */
export function removeMycourse(params) {
    return http({
        url: `/enterprise/course/remove/myCourse`,
        method:"delete",
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 学习中心-加入我的课程
 * 
 */

export function joinUsMycoures(params) {
    return http({
        url: `/enterprise/course/add/myCourse`,
        method:'post',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-随机组卷题型数
 * 
 */
export function countOfQuestionType(params) {
    return http({
        url:`/exam/question/countOfQuestionType?questionClassifyId=${params.questionClassifyId}&paperId=${params.paperId}&businessId=${params.businessId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-题型分析图表
 * 
 */
export function analysisType(params) {
    return http({
        url:`/exam/paperQuestion/analysisType?paperId=${params.paperId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-难度分析图表
 * 
 */
export function analysisTag(params) {
    return http({
        url:`/exam/paperQuestion/analysisTag?paperId=${params.paperId}`,
        method:'get',
        data: params,
        sentType:'enterprise'
    })
}
/**
 *  
 * 教师管理端-试题排序
 * 
 */
export function paperQuestionsSort(params) {
    return http({
        url: `/exam/paperQuestion/sort`,
        method:'put',
        data: params,
        sentType:'enterprise'
    })
}